<template>
    <div class='ur-data-grid__pager' v-if="gridInfo.opts.pagination">
        <ur-pagination :pagination="gridInfo.pager" @move="onPageMove" 
                :simple="gridInfo.opts.simplePagination"/>
    </div>
</template>

<script>
export default {
    name : "urDataGridPager",
    inject : ['gridInfo'],
    methods : {
        onPageMove(cPage) {
            let pager = this.gridInfo.pager;
            pager.currentPage = cPage;
            pager.firstIndex = (pager.currentPage-1)*pager.rowsPerPage;
            
            this.gridInfo.func.resetSelect();
            this.$nextTick(()=>{
                this.gridInfo.func.buildViewData();
            }) // it fires update grid
            // x. fire data... need oldPage?
            this.gridInfo.func.fireEvent("paging",pager);
        }
    }
}
</script>